export class PaginationRowsPerPage{
    Id: string;
    RowsPerPage: string;
}